module.exports = __webpack_public_path__ + "hbomaxar-static/media/Superintelligence_logo_bw.3a029511.png";